import { BRAND } from "constants/brand";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useHome from "hooks/useHome";
import { fieldOf } from "utils/formField";

const SendNotification = (props) => {
    const { sendNotification, loading } = useHome();
    const form = useRef();
    const nodeRef = useRef();

    const submitHandler = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("title", fieldOf(form.current, "title").value);
        formData.append("description", fieldOf(form.current, "description").value);
        formData.append("userId", props.userId);

        try {
            const result = await sendNotification(formData);

            // WHETHER IT REACHED A DEVICE. The API answers `delivered` and
            // `sent`, and returns `sent: 0` for an account with no registered
            // FCM token — 11,083 of 23,917 customers. This used to show
            // «تم الارسال بنجاح» either way, so an admin replying to a complaint
            // was told the reply landed when it had reached nobody.
            //
            // Not an error: the in-app إشعارات row IS written, so the customer
            // sees the reply the next time they open the app. A warning, and it
            // says so, because the operator may want to phone instead.
            if (result?.delivered === false) {
                props.showMessage(
                    "warn",
                    "لم يصل إشعار",
                    "لا يوجد جهاز مسجّل لهذا الزبون. الرسالة محفوظة وستظهر له عند فتح التطبيق.",
                );
            } else {
                props.showMessage("success", "تم الارسال", "تم ارسال اشعار بنجاح");
            }

            props.close();
        } catch (error) {
            props.showMessage(
                "error",
                "تعذر الإرسال",
                error?.response?.data?.message || "حدث خطأ غير متوقع",
            );
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>إرسال اشعار</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="name">
                                <Form.Label>
                                    العنوان<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="title"
                                    type="text"
                                    placeholder="العنوان"
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="desc">
                                <Form.Label>
                                    الوصف<span>*</span>
                                </Form.Label>
                                <Form.Control
                                    name="description"
                                    type="text"
                                    placeholder="الوصف"
                                    required
                                />
                            </Form.Group>
                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    إرسال
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default SendNotification;
